const KCS_MOBILE = "KCS_MOBILE"

export const isMobileApp = window.navigator.userAgent === KCS_MOBILE
